import { Tabs } from 'antd';
import { Dispatch, SetStateAction, useState } from 'react';
import { useDispatch } from 'react-redux';
import getFormatMessage from '../../../locales/get-format-message';
import { SystemMenuId } from '../../../model/system/menu';
import {
  CommonAction,
  ReduxCommonActionType,
} from '../../../store/modules/common';
import { DownLoadItems } from './download-items';
import { DownLoadVersions } from './download-version';
// import { DownLoadRecord } from './download-record';
import { CommonTabs } from '../../../components/tabs';

export const AdminDownLoadManage = () => {
  const [currentTab, setCurrentTab] = useState<string>('DownLoad');

  const menuDispatch = useDispatch<Dispatch<CommonAction>>();
  menuDispatch({
    type: ReduxCommonActionType.SELECT_MENU_ID,
    result: SystemMenuId.DownLoadManage,
  });
  const handleTabChange = (key: SetStateAction<string>) => {
    setCurrentTab(key);
  };

  return (
    <div>
      <CommonTabs activeKey={currentTab} onChange={handleTabChange}>
        <Tabs.TabPane tab={getFormatMessage('downLoad')} key="DownLoad">
          {/* DownLoad内容 */}
          <DownLoadItems />
        </Tabs.TabPane>
        <Tabs.TabPane tab={getFormatMessage('version')} key="Version">
          {/* Version内容 */}
          <DownLoadVersions currentTab={currentTab} />
        </Tabs.TabPane>
        {/* <Tabs.TabPane tab={getFormatMessage('download_record')} key="Record">
          <DownLoadRecord />
        </Tabs.TabPane> */}
      </CommonTabs>
    </div>
  );
};
